import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackSignUpParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackSignUp";

const useTrackSignUp = (parameters: TrackSignUpParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.util.getEventTrackerHook(ga.track.signUp, parameters, options);
};

export default useTrackSignUp;
